import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
`;
export const Main = styled.div`
  display: flex;
  position: relative;
`;
